<div class="d-flex align-items-baseline flex-wrap font-md">
  <div class="me-1">
    {{deliveryDate | i18nDate:'dddd D.'}}
  </div>

  <div class="lowercase me-1">
    {{deliveryDate | i18nDate:'MMM'}}
  </div>

  <div class="me-2">
    {{deliveryTime}}
  </div>

  <ui-days-left-count
    class="text-pink fw-bold"
    [deliveryDate]="deliveryDate"
  ></ui-days-left-count>
</div>
